import SquarePay from '@/apps/billing/views/SquarePay';
export default [
  {
	path: '/billing/squareUpPay/:monto/:oauth/:user_id/:org_id/:typeUser/:customer_id/:invoice_id',
	folder: SquarePay,
  }
];
